// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2poXV","content":"styles_content__2oBH4"};